import React, { PureComponent } from 'react'
import PropTypes from 'prop-types'

import Switch from 'react-ios-switch'

import { Button } from 'controls'
import { colors } from 'theme'

import AppointmentStatus from './AppointmentStatus'

import info from './styles'

export default class extends PureComponent {
  static propTypes = {
    event: PropTypes.object
  }

  render() {
    const { event } = this.props

    return (
      <div className="content">
        <h4 className="header">{event.customEventData.title}</h4>

        <p className="label">Título:</p>
        <p className="value">
          {event.customEventData.title} <br />
        </p>

        <p className="label">Descripción:</p>
        <p className="value">{event.customEventData.description}</p>

        <p className="label">Dirección:</p>
        <p className="value">
          {event.customEventData.address} <br />
        </p>

        <p className="label">Participantes:</p>
        {event.participants.map(p => (
          <p className="value">{p.participantEmail}</p>
        ))}
        <style jsx>{info}</style>
      </div>
    )
  }
}
